import { FC, HTMLAttributes } from "react";

export interface IHTMLViewerAttributes extends HTMLAttributes<HTMLDivElement> {
    content?: string
}

export const HTMLView: FC<IHTMLViewerAttributes> = ({
    content = "", className
}) => {
    return <>
        <div className={className} dangerouslySetInnerHTML={{ __html: content }} />
    </>
}